export default "__VITE_ASSET__C5z50dSc__"